module.exports = __webpack_public_path__ + "img/36514074000193.53452d18.png";